import SlugPage from '../../'

export default SlugPage
